import React, { ReactNode, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { ExtractPropTypes } from 'types';
import { Select } from 'ncoded-component-library';
import { FieldRenderProps } from 'react-final-form';
import { OptionValue } from 'ncoded-component-library/build/components/molecules/Select/Select.component';

import './SelectField.styles.scss';

type SelectComponentProps = ExtractPropTypes<typeof Select>;

export type SelectFieldProps = SelectComponentProps &
  FieldRenderProps<string, HTMLElement> & {
    label?: string;
    className?: string;
    description?: ReactNode;
  };

const SelectField: React.FC<SelectFieldProps> = (props) => {
  const {
    children,
    label,
    description,
    input: { onChange, ...restInput },
    meta: { touched, error },
    required,
    className,
    options,
    ...rest
  } = props;
  const hasError = useMemo(() => touched && error, [error, touched]);

  const classes = classNames(
    'select-field',
    { 'select-field--error': hasError },
    className,
  );

  const handleOnChange = useCallback(
    (values: OptionValue<any>) => {
      onChange(values.value);
    },
    [onChange],
  );

  return (
    <div className={classes}>
      {label && <label className={required && 'required'}>{label}</label>}
      <Select
        {...rest}
        {...restInput}
        onClose={() => restInput.onBlur()}
        hasError={hasError}
        searchInputProps={{
          type: 'search',
          autoComplete: 'chrome-off',
        }}
        options={options}
        onChange={handleOnChange}
        multiple={false}
      />

      {(hasError && <p className="select-field__error-title">{error}</p>) ||
        (description && (
          <p className="select-field__description">{description}</p>
        ))}
    </div>
  );
};

export default SelectField;
